import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

/**
 * Route wrapper that prevents Admins from accessing customer-facing pages.
 * Guests and regular Users are allowed.
 */
const UserRoute = ({ children }) => {
    const { currentUser } = useAuth();

    // Check if user is logged in AND is an admin or staff
    const isAdminOrStaff = currentUser && (
        ['admin', 'staff'].includes((currentUser.role || '').toLowerCase())
    );

    if (isAdminOrStaff) {
        // Redirect admins and staff to dashboard
        return <Navigate to="/admin" replace />;
    }

    return children;
};

export default UserRoute;
